import { createFileRoute, redirect } from "@tanstack/react-router";

// The activity log now lives as the Audit section of the unified Settings area (Fase 5).
export const Route = createFileRoute("/_authenticated/activity/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/audit" });
  },
});
